
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("fyqLX", function(module, exports) {
$parcel$export(module.exports, "removeHyperlinks", () => $375b2c0a7b65cdb2$export$e360ea5d1d6047f3);
const $375b2c0a7b65cdb2$export$e360ea5d1d6047f3 = (message)=>{
    const parser = new DOMParser();
    const parsedMessage = parser.parseFromString(message, 'text/html');
    parsedMessage.querySelectorAll('a').forEach((a)=>{
        // Removing href attribute from anchor tag and setting tabindex to -1 to disable keyboard navigation
        // eslint-disable-next-line no-script-url
        a.setAttribute('href', 'javascript:void(0)');
        a.setAttribute('tabindex', '-1');
        a.setAttribute('draggable', 'false');
        a.setAttribute('style', 'text-decoration: none; color: inherit; cursor: inherit;');
    });
    return parsedMessage.body.innerHTML;
};

});

parcelRegister("4qlmX", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSinglePortal", () => $bf74d0ede5efdbeb$export$277ee7633ebb3a3e);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $g4BKO = parcelRequire("g4BKO");

var $gUbcQ = parcelRequire("gUbcQ");

var $ik9zp = parcelRequire("ik9zp");

var $3GBA9 = parcelRequire("3GBA9");

var $eRG8F = parcelRequire("eRG8F");

var $fK5uK = parcelRequire("fK5uK");

var $kIbto = parcelRequire("kIbto");

var $2usNr = parcelRequire("2usNr");

var $haAAx = parcelRequire("haAAx");

var $gEVth = parcelRequire("gEVth");

var $jrpJ3 = parcelRequire("jrpJ3");
class $bf74d0ede5efdbeb$export$e82959fec4c24ef2 extends $bSJIT.Component {
    componentDidMount() {
        const { fetchCategories: fetchCategories, fetchPortal: fetchPortal, projectId: projectId, portalId: portalId, isKbEnabled: isKbEnabled } = this.props;
        // To fetch categories we need the projectId, to get projectId we need the portal.
        // This will result in sequential requests where it does the following:
        // Load help center -> load portal -> load categories -> FINALLY show content.
        if (projectId && isKbEnabled) {
            const meta = this.getFetchCategoryAnalyticsEvents();
            fetchCategories(projectId, portalId, meta);
        }
        // We need to also fetch the kb for the portal here so that we get a consistent state after selecting a request group
        // and navigating to a portal
        const analytics = this.getViewSinglePortalAnalyticsEvents();
        fetchPortal({
            id: portalId,
            expand: [
                'reqTypes',
                'reqGroups',
                'orderMapping',
                'kbs'
            ]
        }, analytics);
    }
    componentDidUpdate(prevProps) {
        const { projectId: projectId, portalId: portalId, fetchCategories: fetchCategories, isKbEnabled: isKbEnabled } = this.props;
        if (prevProps.projectId !== projectId && projectId && isKbEnabled) {
            const meta = this.getFetchCategoryAnalyticsEvents();
            fetchCategories(projectId, portalId, meta);
        }
    }
    render() {
        const { loading: loading, fetchCategories: fetchCategories, fetchPortal: fetchPortal, isKbEnabled: isKbEnabled, ...props } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $fK5uK.LoadingContainer), {
            isLoading: loading,
            loadingPosition: "fill-container",
            interactionName: 'help-center-single-portal'
        }, /*#__PURE__*/ $bSJIT.createElement((0, $jrpJ3.default), {
            ...props,
            FormPicker: (0, $eRG8F.FormPicker),
            CategoryList: (0, $3GBA9.CategoryList)
        }));
    }
    constructor(...args){
        super(...args), this.getFetchCategoryAnalyticsEvents = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return {
                analyticsSuccessEvent: createAnalyticsEvent({
                    action: 'fetchCategories success',
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                }),
                analyticsFailureEvent: createAnalyticsEvent({
                    action: 'fetchCategories error',
                    analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE)
                })
            };
            return {};
        }, this.getViewSinglePortalAnalyticsEvents = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return {
                analyticsSuccessEvent: createAnalyticsEvent({
                    action: (0, $gEVth.AnalyticsTrackActions).FETCHED,
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                    actionSubject: 'singlePortal'
                }),
                analyticsFailureEvent: createAnalyticsEvent({
                    action: (0, $gEVth.AnalyticsTrackActions).FETCHED_FAILURE,
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                    actionSubject: 'singlePortal'
                })
            };
            return {};
        };
    }
}
const $bf74d0ede5efdbeb$var$selector = (0, $BOq7h.createSelector)((state, props)=>(0, $ik9zp.getIsPortalLoaded)(state, props.portalId), (state, props)=>(0, $ik9zp.getPortalRequestGroups)(state, props.portalId), (state, props)=>(0, $ik9zp.getPortalRequestTypes)(state, props.portalId), (state, props)=>(0, $ik9zp.getCategories)(state, props.portalId), (state, props)=>(0, $ik9zp.getProjectId)(state, props.portalId), (state, props)=>(0, $ik9zp.getIsKbEnabled)(state, props.portalId), (state, props)=>(0, $ik9zp.getDescription)(state, props.portalId), (isPortalLoaded, requestGroups, requestTypes, categories, projectId, isKbEnabled, description)=>{
    const knowledgeBaseHasCategories = Array.isArray(categories) ? categories.length > 0 : false;
    return {
        requestGroups: requestGroups,
        requestTypes: requestTypes,
        projectId: projectId,
        isKbEnabled: isKbEnabled,
        description: description,
        knowledgeBaseHasCategories: knowledgeBaseHasCategories,
        loading: !isPortalLoaded || isKbEnabled && !categories
    };
});
const $bf74d0ede5efdbeb$export$277ee7633ebb3a3e = (0, $egQxE.connect)($bf74d0ede5efdbeb$var$selector, {
    fetchPortal: (0, $gUbcQ.fetchPortalAction),
    fetchCategories: (0, $g4BKO.fetchCategoriesAction)
})((0, $2usNr.default)({
    componentName: 'PortalHome'
})((0, $kIbto.default)()($bf74d0ede5efdbeb$export$e82959fec4c24ef2)));

});
parcelRegister("jrpJ3", function(module, exports) {
$parcel$export(module.exports, "default", () => $36faf0c215b0787f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $4QZgG = parcelRequire("4QZgG");
parcelRequire("3009B");
var $4mUF0 = parcelRequire("4mUF0");

var $6vu3o = parcelRequire("6vu3o");

var $c3QJe = parcelRequire("c3QJe");

var $fyqLX = parcelRequire("fyqLX");
const $36faf0c215b0787f$var$SinglePortal = ({ FormPicker: FormPicker, CategoryList: CategoryList, portalId: portalId, projectId: projectId, requestTypeSuggestion: requestTypeSuggestion, description: description, knowledgeBaseHasCategories: knowledgeBaseHasCategories, isEmbeddedRoute: isEmbeddedRoute })=>{
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    let descriptionToRender = description;
    if (isPageInEditMode && !!description) descriptionToRender = (0, $fyqLX.removeHyperlinks)(description);
    return /*#__PURE__*/ $bSJIT.createElement($36faf0c215b0787f$var$Root, null, !!description && /*#__PURE__*/ $bSJIT.createElement($36faf0c215b0787f$var$Description, {
        dangerouslySetInnerHTML: {
            __html: descriptionToRender
        }
    }), knowledgeBaseHasCategories && /*#__PURE__*/ $bSJIT.createElement($36faf0c215b0787f$var$ContentContainer, null, /*#__PURE__*/ $bSJIT.createElement(CategoryList, {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Suppressing existing violation. Please fix this.
        cardLinkAppearance: "white",
        portalId: portalId,
        isEmbeddedRoute: isEmbeddedRoute
    })), !knowledgeBaseHasCategories && /*#__PURE__*/ $bSJIT.createElement($36faf0c215b0787f$var$ContentContainer, null, /*#__PURE__*/ $bSJIT.createElement(FormPicker, {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Suppressing existing violation. Please fix this.
        cardLinkAppearance: "white",
        portalId: portalId,
        isEmbeddedRoute: isEmbeddedRoute
    })), requestTypeSuggestion.length > 0 && /*#__PURE__*/ $bSJIT.createElement((0, $6vu3o.RecentForms), {
        suggestedRequestTypes: requestTypeSuggestion,
        isEmbeddedRoute: isEmbeddedRoute
    }), projectId && /*#__PURE__*/ $bSJIT.createElement($36faf0c215b0787f$var$ExternalLinksListWrapper, null, /*#__PURE__*/ $bSJIT.createElement((0, $4QZgG.ExternalLinks), {
        projectId: projectId
    })));
};
var $36faf0c215b0787f$export$2e2bcd8739ae039 = $36faf0c215b0787f$var$SinglePortal;
const $36faf0c215b0787f$var$BOTTOM_MARGIN_PX = "var(--ds-space-600, 48px)";
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $36faf0c215b0787f$var$Root = /*#__PURE__*/ (0, $4v2A7.default)((0, $4mUF0.HelpCenterContainer)).withConfig({
    componentId: "sc-1s5a3o5-0"
})`margin-top:${"var(--ds-space-400, 32px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $36faf0c215b0787f$var$Description = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1s5a3o5-1"
})`margin:0 0 ${"var(--ds-space-400, 32px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $36faf0c215b0787f$var$ContentContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1s5a3o5-2"
})`margin-bottom:${$36faf0c215b0787f$var$BOTTOM_MARGIN_PX};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $36faf0c215b0787f$var$ExternalLinksListWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1s5a3o5-3"
})`margin-top:${"var(--ds-space-400, 32px)"};margin-bottom:${"var(--ds-space-400, 32px)"};`;

});
parcelRegister("3009B", function(module, exports) {
$parcel$export(module.exports, "HelpCenterContainer", () => (parcelRequire("4mUF0")).HelpCenterContainer);

var $4mUF0 = parcelRequire("4mUF0");

});
parcelRegister("4mUF0", function(module, exports) {
$parcel$export(module.exports, "HelpCenterContainer", () => $b84537fa14ebbddb$export$d86480715a8af64);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $ki6Qt = parcelRequire("ki6Qt");

var $fU62V = parcelRequire("fU62V");

var $a7Tmb = parcelRequire("a7Tmb");
const $b84537fa14ebbddb$export$d86480715a8af64 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-9csls6-0"
})`${$fU62V.borderBox};width:100%;margin:0 auto;padding-left:${"var(--ds-space-400, 32px)"};padding-right:${"var(--ds-space-400, 32px)"};${$ki6Qt.fromSmall.css`
        max-width: ${(0, $a7Tmb.sizes).small}px;
        /* We deliberately use padding-right/left so we can override top/bottom easily. */
        padding-right: ${"var(--ds-space-600, 48px)"};
        padding-left: ${"var(--ds-space-600, 48px)"};
    `};`;

});


parcelRegister("6vu3o", function(module, exports) {
$parcel$export(module.exports, "RecentForms", () => $17ac9d06d937206f$export$27e3ed4af71aea22);

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $aI0YR = parcelRequire("aI0YR");

var $3T6R0 = parcelRequire("3T6R0");
const $17ac9d06d937206f$var$selector = (0, $BOq7h.createSelector)((0, $aI0YR.isLoggedIn), (isUserLoggedIn)=>({
        isUserLoggedIn: isUserLoggedIn
    }));
const $17ac9d06d937206f$export$27e3ed4af71aea22 = (0, $egQxE.connect)($17ac9d06d937206f$var$selector)((0, $3T6R0.default));

});
parcelRegister("3T6R0", function(module, exports) {
$parcel$export(module.exports, "default", () => $831b4c6c2450cfdd$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $acAb6 = parcelRequire("acAb6");

var $fT4XN = parcelRequire("fT4XN");

var $98sDU = parcelRequire("98sDU");

var $5cKiX = parcelRequire("5cKiX");

var $aFV7z = parcelRequire("aFV7z");

var $9iMuS = parcelRequire("9iMuS");
parcelRequire("2rllo");
var $h4AWZ = parcelRequire("h4AWZ");
const $831b4c6c2450cfdd$var$ConditionalErrorBoundaryWrapper = ({ children: children })=>/*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
        id: "recent-forms",
        packageName: "featured-and-sorted-portals"
    }, children);
class $831b4c6c2450cfdd$export$2e2bcd8739ae039 extends $bSJIT.Component {
    render() {
        const { suggestedRequestTypes: suggestedRequestTypes, isUserLoggedIn: isUserLoggedIn, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        const headerTitle = isUserLoggedIn ? (0, $9iMuS.default).headerTitle : (0, $9iMuS.default).headerTitleAnon;
        return /*#__PURE__*/ $bSJIT.createElement($831b4c6c2450cfdd$var$ConditionalErrorBoundaryWrapper, null, /*#__PURE__*/ $bSJIT.createElement($831b4c6c2450cfdd$var$RecentFormsHeader, null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), headerTitle)), /*#__PURE__*/ $bSJIT.createElement($831b4c6c2450cfdd$var$RecentFormsContainer, null, suggestedRequestTypes.map((recentRequestSuggestion, recentFormIndex)=>{
            const Icon = /*#__PURE__*/ $bSJIT.createElement((0, $acAb6.default), {
                src: recentRequestSuggestion.iconUrl,
                alt: "",
                draggable: "false"
            });
            const LinkAndDescription = /*#__PURE__*/ $bSJIT.createElement((0, $h4AWZ.default), {
                ...recentRequestSuggestion,
                onClick: this.onClick(recentFormIndex),
                isEmbeddedRoute: isEmbeddedRoute
            });
            return /*#__PURE__*/ $bSJIT.createElement($831b4c6c2450cfdd$var$RecentFormItem, {
                key: `recentRequestSuggestion_${recentRequestSuggestion.id}`
            }, /*#__PURE__*/ $bSJIT.createElement((0, $aFV7z.IconCardLayout), {
                padding: 0,
                leftIcon: Icon,
                content: LinkAndDescription
            }));
        })));
    }
    constructor(...args){
        super(...args), this.onClick = (index)=>()=>{
                const { onClick: onClick } = this.props;
                onClick && onClick(index);
            };
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $831b4c6c2450cfdd$var$RecentFormsContainer = /*#__PURE__*/ (0, $4v2A7.default).ul.withConfig({
    componentId: "sc-1qfzoqw-0"
})`display:block;list-style:none;padding:0;margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $831b4c6c2450cfdd$var$RecentFormsHeader = /*#__PURE__*/ (0, $4v2A7.default).h2.withConfig({
    componentId: "sc-1qfzoqw-1"
})`${$98sDU.h500};padding-bottom:${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $831b4c6c2450cfdd$var$RecentFormItem = /*#__PURE__*/ (0, $4v2A7.default).li.withConfig({
    componentId: "sc-1qfzoqw-2"
})`display:block;word-wrap:break-word;position:relative;padding-bottom:${"var(--ds-space-200, 16px)"};`;

});
parcelRegister("9iMuS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6dba8402dc39ab3$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $e6dba8402dc39ab3$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    headerTitle: {
        defaultMessage: 'Recently used request forms',
        description: 'Title for recently used forms component in Help Center',
        id: 'cv.smart.portal.recent.request.types.header'
    },
    headerTitleAnon: {
        defaultMessage: 'Suggested forms',
        description: 'Title for recently used forms component in Help Center when user is anonymous',
        id: 'cv.smart.portal.recent.request.types.anonymous.header'
    }
});

});

parcelRegister("2rllo", function(module, exports) {
$parcel$export(module.exports, "RecentFormsListItem", () => (parcelRequire("h4AWZ")).default);

var $h4AWZ = parcelRequire("h4AWZ");

});
parcelRegister("h4AWZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $955313c89a018f88$export$2e2bcd8739ae039);
/* recent-forms-list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxFrag React.Fragment */ /** @jsxRuntime classic */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $2OuWT = parcelRequire("2OuWT");

var $fU62V = parcelRequire("fU62V");

var $5cKiX = parcelRequire("5cKiX");

var $c3QJe = parcelRequire("c3QJe");

var $dwOcU = parcelRequire("dwOcU");

var $87QgR = parcelRequire("87QgR");

var $iCvmT = parcelRequire("iCvmT");
const $955313c89a018f88$var$RECENT_FORM_DESCRIPTION_WRAPPING = 'jsdcloud_18837_recent_form_description_wrapping';
const $955313c89a018f88$var$isRecentFormDescriptionWrappingEnabled = ()=>(0, $87QgR.default).checkGate($955313c89a018f88$var$RECENT_FORM_DESCRIPTION_WRAPPING);
const $955313c89a018f88$var$wrappingDescriptionStyles = null;
const $955313c89a018f88$var$RecentFormsListItem = ({ portalId: portalId, portalName: portalName, name: name, descriptionHtml: descriptionHtml, onClick: onClick, isEmbeddedRoute: isEmbeddedRoute, id: requestTypeId })=>{
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            attributes: {
                requestTypeId: requestTypeId
            }
        }
    }, /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, isPageInEditMode ? /*#__PURE__*/ $bSJIT.createElement($955313c89a018f88$var$Title, null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $iCvmT.default).linkText,
        values: {
            portalName: portalName,
            formName: name
        }
    })) : // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/no-static-element-interactions, styled-components-a11y/anchor-is-valid, styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions -- Disabling existing violation, should be fixed when revisited.
    /*#__PURE__*/ $bSJIT.createElement($955313c89a018f88$var$FormLink, {
        to: `/portal/${portalId}/create/${requestTypeId}`,
        onClick: onClick,
        actionSubjectId: "suggestionRequestType",
        target: isEmbeddedRoute ? '_blank' : undefined
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $iCvmT.default).linkText,
        values: {
            portalName: portalName,
            formName: name
        }
    })), $955313c89a018f88$var$isRecentFormDescriptionWrappingEnabled() ? /*#__PURE__*/ $bSJIT.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: descriptionHtml
        },
        className: (0, $9fU1q.default)([
            "_1i4qfg65"
        ])
    }) : /*#__PURE__*/ $bSJIT.createElement($955313c89a018f88$var$Description, {
        dangerouslySetInnerHTML: {
            __html: descriptionHtml
        }
    })));
};
var $955313c89a018f88$export$2e2bcd8739ae039 = $955313c89a018f88$var$RecentFormsListItem;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $955313c89a018f88$var$FormLink = /*#__PURE__*/ (0, $4v2A7.default)((0, $2OuWT.Link)).withConfig({
    componentId: "sc-16hdtko-0"
})`color:${(props)=>`var(--ds-link, ${props.theme.color})`};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $955313c89a018f88$var$Description = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-16hdtko-1"
})`& p{${$fU62V.clamp};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $955313c89a018f88$var$Title = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-16hdtko-2"
})`color:${(props)=>`var(--ds-link, ${props.theme.color})`};`;

});
parcelRegister("iCvmT", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d3564d8fc9a269f$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $5d3564d8fc9a269f$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    linkText: {
        defaultMessage: '{formName} in {portalName}',
        description: 'Text used inside the recently used form link',
        id: 'cv.smart.portal.recent.request.types.link'
    }
});

});








//# sourceMappingURL=shared.51b504e4.js.map
